import React, { Component } from 'react';

import './style.css';


export default class HeaderTop extends Component {
  render() {
    return (
      <div className='header__top' ref='topContainer'>
        <div className='header__container'>
          <div className='header__history-links'>
            <a href='http://2015-autumn.happydev-lite.ru/' target='_blank' className='header__history-link'>lite'15 сентябрь</a>
            <a href='http://2016-spring.happydev-lite.ru/' target='_blank' className='header__history-link'>lite'16 апрель</a>
            <a href='http://2016-autumn.happydev-lite.ru/' target='_blank' className='header__history-link'>lite'16 сентябрь</a>
            <a href='http://2017-spring.happydev-lite.ru/' target='_blank' className='header__history-link'>lite'17 март</a>
          </div>
          <div className='header__following-container'>
            <a className='header__following-link' href='http://bit.ly/hdl-2017-spring-vk-from-site' target='_blank'>
              <div className='header__following-vk' />
            </a>
            <a className='header__following-link' href='http://bit.ly/hdl-2017-spring-twitter-from-site' target='_blank'>
              <div className='header__following-twitter' />
            </a>
            <a className='header__following-link' href='http://bit.ly/hdl-2017-spring-youtube-from-site' target='_blank'>
              <div className='header__following-youtube' />
            </a>
            {/*<a href='http://blog.happydev-lite.ru/' className='header__following-blog' target='_blank'>блог happydev</a>*/}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layout-page/blocks/header-top/HeaderTop.js